export class ManualEpisodesModel {
    constructor(episodesData) {
        this.episodesTitle = episodesData.title;
        this.audioURL = episodesData.audioURL;
        this.description = episodesData.description;
        this.imageURL = episodesData.imageURL;
        this.episodeEmbedId = episodesData.embedId;
    }

    get episodes() {
        return {
            podcastImageUrl: this.imageURL,
            podcastImageAlt: this.episodesTitle,
            episodes: [{
                episodeTitle: this.episodesTitle,
                episodeSrc: this.audioURL,
                episodeDescription: this.description,
                episodeEmbedId : this.episodeEmbedId,
            }]
        };
    }
}
